// If updating data -
// 1. download sheet as JSON with right property names as in `data/rawData`
// 2. use `formatFinalData` from `utils/helper` and copy paste it here

export const data = [
  {
    qId: 0,
    text: "Close your eyes and picture your ideal Thanksgiving celebration. What's the vibe?",
    categoriesFiltered: [
      "drinks",
      "app",
      "mains",
      "stuffing",
      "potatoes",
      "sweet-potatoes",
      "bread",
      "sides",
      "salads",
      "cranberry",
      "pie",
      "dessert",
    ],
    options: [
      {
        text: "Comforting and classic",
        nextQId: 2,
        possibleResultsIds: [
          8, 10, 12, 14, 15, 16, 11, 1, 2, 3, 5, 6, 130, 132, 133, 134, 17, 18,
          21, 23, 26, 28, 29, 30, 135, 136, 137, 139, 143, 32, 37, 38, 39, 173,
          40, 42, 43, 44, 46, 48, 49, 53, 55, 56, 58, 60, 65, 78, 81, 83, 85,
          87, 88, 89, 174, 70, 61, 71, 77, 75, 90, 91, 93, 160, 95, 96, 97, 100,
          104, 105, 111, 112, 161, 114, 124, 117, 118, 120, 121, 126, 127, 123,
          124, 166, 178,
        ],
      },
      {
        text: "Ready to have fun! This menu has no rules",
        nextQId: 2,
        possibleResultsIds: [
          8, 9, 11, 13, 15, 16, 170, 1, 3, 4, 5, 7, 21, 22, 24, 25, 27, 30, 145,
          146, 147, 148, 31, 32, 34, 33, 35, 36, 38, 39, 173, 40, 41, 43, 45,
          47, 49, 51, 52, 54, 59, 62, 63, 68, 79, 82, 84, 88, 89, 70, 73, 154,
          155, 156, 157, 90, 92, 93, 98, 102, 104, 106, 108, 109, 110, 111, 114,
          122, 125, 114, 115, 118, 121, 126, 127, 124, 166, 165, 167, 168, 169,
          74,
        ],
      },
      {
        text: "Everything extra—a true blowout",
        nextQId: 2,
        possibleResultsIds: [
          8, 9, 10, 11, 15, 16, 171, 1, 3, 4, 5, 7, 17, 18, 22, 23, 24, 25, 26,
          30, 138, 140, 141, 142, 144, 145, 149, 150, 151, 31, 32, 34, 33, 35,
          36, 38, 173, 40, 41, 43, 45, 47, 50, 52, 57, 53, 55, 57, 59, 60, 63,
          64, 66, 67, 79, 80, 84, 87, 88, 89, 175, 176, 70, 73, 71, 158, 156,
          69, 90, 92, 93, 94, 96, 97, 102, 104, 106, 107, 111, 112, 162, 113,
          125, 116, 117, 118, 121, 126, 127, 122, 166,
        ],
      },
      {
        text: "Easy and low-stress",
        nextQId: 2,
        possibleResultsIds: [
          8, 11, 13, 14, 15, 16, 172, 1, 2, 6, 128, 129, 130, 131, 19, 20, 21,
          23, 24, 29, 30, 146, 152, 153, 137, 32, 36, 37, 38, 39, 173, 40, 42,
          43, 44, 46, 48, 49, 53, 54, 55, 58, 60, 63, 68, 78, 81, 83, 85, 86,
          176, 177, 70, 72, 75, 159, 75, 91, 93, 160, 96, 97, 99, 101, 104, 105,
          111, 112, 163, 164, 113, 119, 118, 121, 126, 127, 166, 165, 178,
        ],
      },
    ],
  },
  {
    qId: 1,
    text: "Do you eat gluten?",
    categoriesFiltered: [
      "app",
      "mains",
      "stuffing",
      "potatoes",
      "sweet-potatoes",
      "bread",
      "sides",
      "salads",
      "cranberry",
      "pie",
      "dessert",
    ],
    options: [
      {
        text: "Nope, please avoid",
        nextQId: 3,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 133, 18, 20, 22, 23, 29, 30, 137, 138, 139, 143,
          144, 145, 146, 147, 148, 149, 150, 32, 36, 173, 40, 41, 42, 43, 44,
          45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 60, 62, 63, 64, 65, 67, 68,
          78, 79, 82, 83, 84, 85, 86, 174, 175, 176, 177, 70, 71, 75, 154, 156,
          90, 91, 92, 93, 160, 109, 112, 121, 126, 127, 124, 166, 165, 178,
        ],
      },
      {
        text: "Bring on the gluten!",
        nextQId: 3,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 134, 17, 19, 21, 22, 23, 24, 25, 26, 27, 28,
          30, 135, 136, 138, 139, 140, 141, 142, 146, 147, 151, 152, 153, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
          49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66,
          68, 78, 79, 80, 81, 82, 84, 85, 87, 88, 89, 174, 177, 61, 75, 77, 76,
          73, 155, 157, 158, 159, 69, 72, 90, 91, 92, 93, 160, 94, 95, 96, 97,
          98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 161,
          162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 122, 123, 120, 125,
          127,
        ],
      },
    ],
  },
  {
    qId: 2,
    text: "How many people at the table?",
    categoriesFiltered: ["drinks", "mains"],
    options: [
      {
        text: "One or two",
        nextQId: 1,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7, 128,
          129, 130, 131, 132, 133, 134, 21, 22, 23, 24, 26, 27, 28, 29, 30, 135,
          136, 137, 140, 141, 143, 145, 147, 148, 149, 150, 152, 153, 173, 31,
          32, 34, 33, 35, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
          50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67,
          68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176,
          177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90,
          91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106,
          107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 115, 116,
          117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 166, 165, 167,
          168, 169, 74, 178,
        ],
      },
      {
        text: "Three to six",
        nextQId: 1,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7, 128,
          129, 130, 131, 132, 133, 134, 19, 20, 21, 25, 24, 26, 27, 28, 29, 30,
          135, 136, 137, 138, 139, 140, 142, 143, 144, 147, 148, 149, 150, 151,
          152, 153, 173, 31, 32, 34, 33, 35, 37, 38, 39, 40, 41, 42, 43, 44, 45,
          46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63,
          64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
          174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "More than six",
        nextQId: 1,
        possibleResultsIds: [
          8, 9, 12, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7, 128, 129,
          130, 131, 132, 133, 134, 17, 18, 19, 20, 24, 22, 26, 27, 28, 29, 30,
          135, 136, 137, 140, 143, 146, 147, 148, 149, 150, 151, 152, 153, 36,
          31, 32, 34, 33, 35, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
          49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66,
          67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176,
          177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90,
          91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106,
          107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 115, 116,
          117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 166, 165, 167,
          168, 169, 74, 178,
        ],
      },
    ],
  },
  {
    qId: 3,
    text: "Should there be meat on the menu?",
    categoriesFiltered: [
      "app",
      "mains",
      "stuffing",
      "potatoes",
      "sweet-potatoes",
      "bread",
      "sides",
      "salads",
      "cranberry",
      "pie",
      "dessert",
    ],
    options: [
      {
        text: "Anything goes!",
        nextQId: 4,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 2, 3, 4, 6, 7, 129,
          17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 135, 136, 137, 138, 139, 140,
          143, 144, 145, 146, 147, 152, 31, 32, 34, 35, 36, 37, 39, 173, 40, 41,
          42, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 56, 57, 58, 59, 60, 62,
          65, 66, 68, 78, 79, 87, 88, 175, 176, 61, 77, 76, 73, 155, 157, 158,
          159, 69, 72, 70, 71, 75, 154, 156, 90, 91, 92, 93, 94, 95, 97, 98, 99,
          100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 112, 161, 162, 163,
          164, 113, 114, 115, 116, 117, 119, 126, 122, 123, 124, 125, 120, 166,
        ],
      },
      {
        text: "No, we’re vegetarian",
        nextQId: 4,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 4, 7, 130, 132,
          27, 28, 148, 150, 151, 153, 32, 39, 40, 41, 42, 44, 45, 46, 48, 49,
          50, 51, 52, 54, 55, 56, 57, 58, 59, 62, 64, 65, 67, 68, 80, 81, 82,
          83, 84, 85, 88, 174, 61, 77, 76, 73, 155, 157, 158, 159, 69, 72, 70,
          71, 75, 154, 156, 91, 92, 93, 94, 95, 97, 98, 99, 100, 101, 102, 104,
          105, 106, 107, 108, 109, 110, 112, 161, 162, 163, 164, 113, 114, 115,
          116, 117, 119, 126, 122, 123, 125, 166, 178,
        ],
      },
      {
        text: "No, we’re vegan",
        nextQId: 4,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 4, 7, 130, 132,
          26, 27, 29, 148, 149, 153, 38, 43, 49, 52, 55, 63, 67, 68, 82, 83, 84,
          86, 89, 70, 71, 75, 154, 156, 92, 93, 160, 96, 111, 118, 121, 127,
        ],
      },
      {
        text: "We don’t eat pork",
        nextQId: 4,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 2, 4, 5, 7, 128, 131,
          133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 30, 135, 136,
          137, 138, 139, 141, 142, 143, 144, 146, 145, 147, 152, 33, 35, 39, 32,
          40, 41, 42, 44, 45, 46, 48, 49, 50, 51, 52, 54, 55, 56, 57, 58, 59,
          62, 64, 65, 67, 68, 78, 79, 84, 85, 88, 177, 61, 77, 76, 73, 155, 157,
          158, 159, 69, 72, 70, 71, 75, 154, 156, 91, 92, 93, 94, 95, 97, 98,
          99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 112, 161, 162,
          163, 164, 113, 114, 115, 116, 117, 119, 121, 126, 122, 123, 120, 125,
          166,
        ],
      },
    ],
  },
  {
    qId: 4,
    text: "What’s your go-to mixed drink?",
    categoriesFiltered: ["drinks"],
    options: [
      {
        text: "Nonalcoholic, please",
        nextQId: 5,
        possibleResultsIds: [
          12, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133,
          134, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136,
          137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150,
          151, 152, 153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42,
          43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
          60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86,
          87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154,
          155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99,
          100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162,
          163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
          125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Brisk and strong (stirred, not shaken)",
        nextQId: 5,
        possibleResultsIds: [
          8, 1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133, 134, 17, 18, 19,
          20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137, 138, 139,
          140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153,
          31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46,
          47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64,
          65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174,
          175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157,
          158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102,
          104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113,
          114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
          166, 178,
        ],
      },
      {
        text: "Something bitter",
        nextQId: 5,
        possibleResultsIds: [
          9, 14, 1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133, 134, 17, 18,
          19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137, 138,
          139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152,
          153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45,
          46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63,
          64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
          174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "Something fizzy",
        nextQId: 5,
        possibleResultsIds: [
          10, 13, 15, 1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133, 134,
          17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137,
          138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
          152, 153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44,
          45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62,
          63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
          89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "Fruity and seasonally appropriate",
        nextQId: 5,
        possibleResultsIds: [
          11, 16, 1, 2, 3, 4, 5, 6, 7, 128, 129, 130, 131, 132, 133, 134, 17,
          18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137,
          138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
          152, 153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44,
          45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62,
          63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
          89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 5,
    text: "What’s your Thanksgiving snacking style?",
    categoriesFiltered: ["app"],
    options: [
      {
        text: "Snacks are the fun part!",
        nextQId: 6,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 3, 5, 128, 129,
          17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137,
          138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151,
          152, 153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44,
          45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62,
          63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
          89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "I prefer a proper appetizer course",
        nextQId: 6,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 6, 7, 130, 131, 132,
          133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135,
          136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149,
          150, 151, 152, 153, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41,
          42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
          59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85,
          86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77,
          154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98,
          99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161,
          162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Keep it light—I don't want to fill up!",
        nextQId: 6,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 2, 4, 17, 18, 19, 20,
          21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140,
          141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 31,
          32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47,
          48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65,
          66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175,
          176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158,
          159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104,
          105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113, 114,
          115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 166,
          178,
        ],
      },
    ],
  },
  {
    qId: 6,
    text: "Which statement best matches your feelings on the main course?",
    categoriesFiltered: ["mains"],
    options: [
      {
        text: "Gotta have the big bird",
        nextQId: 7,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 23, 138, 139, 147,
          31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46,
          47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64,
          65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174,
          175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157,
          158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102,
          104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113,
          114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
          166,
        ],
      },
      {
        text: "I want to make turkey—and something for vegetarians",
        nextQId: 7,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 30, 31, 32, 33, 34, 35, 36, 37, 38,
          39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54,
          55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81,
          82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72,
          73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94,
          95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
          111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166,
        ],
      },
      {
        text: "I'm tired of turkey, let's try something else",
        nextQId: 7,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 21, 140, 141, 142, 143, 144, 145,
          146, 31, 32, 33, 34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45,
          46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63,
          64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
          174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166,
        ],
      },
      {
        text: "I’m just in it for the turkey sandwiches",
        nextQId: 7,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 24, 135, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118,
          119, 120, 121, 122, 123, 124, 125, 126, 127, 166, 165, 167, 168, 169,
          74,
        ],
      },
      {
        text: "Dark meat is the only turkey worth eating",
        nextQId: 7,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 22, 25, 136, 137, 152, 31, 32, 33,
          34, 35, 36, 37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
          50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67,
          68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176,
          177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90,
          91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106,
          107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 115, 116,
          117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 166, 165, 167,
          168, 169, 74,
        ],
      },
    ],
  },
  {
    qId: 7,
    text: "Complete the sentence: Stuffing (or dressing) must have…",
    categoriesFiltered: ["stuffing"],
    options: [
      {
        text: "Sausage",
        nextQId: 8,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 37, 40, 41, 42, 43,
          44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
          62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
          88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155,
          156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100,
          101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163,
          164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
          126, 127, 166, 178,
        ],
      },
      {
        text: "Cornbread",
        nextQId: 8,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 33, 36, 173, 40, 41, 42,
          43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
          60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86,
          87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154,
          155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99,
          100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162,
          163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
          125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Rice",
        nextQId: 8,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 32, 34, 40, 41, 42, 43,
          44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
          62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
          88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155,
          156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100,
          101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163,
          164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
          126, 127, 166, 178,
        ],
      },
      {
        text: "Oysters",
        nextQId: 8,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 35, 40, 41, 42, 43, 44,
          45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62,
          63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
          89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "Just the essentials, including classic Thanksgiving herbs",
        nextQId: 8,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 39, 40, 41, 42, 43, 44,
          45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 62,
          63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88,
          89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155, 156,
          157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 8,
    text: "Your preferred potatoes?",
    categoriesFiltered: ["potatoes"],
    options: [
      {
        text: "Always creamy",
        nextQId: 9,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
          60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86,
          87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154,
          155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99,
          100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162,
          163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
          125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Always crispy",
        nextQId: 9,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 43, 44, 45, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
          58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84,
          85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76,
          77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97,
          98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112,
          161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
          123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Baked into a gratin",
        nextQId: 9,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 41, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
          59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85,
          86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77,
          154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98,
          99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161,
          162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Made ahead for minimum fuss",
        nextQId: 9,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 42, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
          59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85,
          86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77,
          154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98,
          99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161,
          162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Who needs potatoes?",
        nextQId: 9,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
          62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87,
          88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154, 155,
          156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100,
          101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163,
          164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
          126, 127, 166, 165, 168, 169, 74, 178,
        ],
      },
    ],
  },
  {
    qId: 9,
    text: "What's your hot take on sweet potatoes?",
    categoriesFiltered: ["sweet-potatoes"],
    options: [
      {
        text: "The casserole is sacred",
        nextQId: 10,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 49, 53, 54, 55, 56,
          57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83,
          84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75,
          76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96,
          97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Keep your marshmallows away from my sweet potatoes",
        nextQId: 10,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 50, 51, 53, 54,
          55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81,
          82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72,
          73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94,
          95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
          111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Make ‘em spicy",
        nextQId: 10,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 52, 53, 54, 55, 56,
          57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83,
          84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75,
          76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96,
          97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Sweet potatoes only belong in dessert",
        nextQId: 10,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 53, 54, 55, 56, 57,
          58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84,
          85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76,
          77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97,
          98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112,
          161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
          123, 124, 125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 10,
    text: "What's in the bread basket?",
    categoriesFiltered: ["bread"],
    options: [
      {
        text: "Gotta have cornbread",
        nextQId: 11,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83,
          84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75,
          76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96,
          97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Must have dinner rolls or popovers",
        nextQId: 11,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          56, 57, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84,
          85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76,
          77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97,
          98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112,
          161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
          123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Biscuits, please",
        nextQId: 11,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84,
          85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76,
          77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97,
          98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112,
          161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
          123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Skip it, I’ll take my bread in stuffing form",
        nextQId: 11,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          60, 62, 63, 64, 65, 66, 67, 68, 78, 79, 80, 81, 82, 83, 84, 85, 86,
          87, 88, 89, 174, 175, 176, 177, 69, 70, 71, 72, 73, 75, 76, 77, 154,
          155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99,
          100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162,
          163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
          125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 11,
    text: "Which cooked vegetable side is most essential to you?",
    categoriesFiltered: ["sides"],
    options: [
      {
        text: "Green beans",
        nextQId: 12,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 65, 66, 67, 68, 175, 69, 70, 71, 72, 73,
          75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95,
          96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Brussels sprouts",
        nextQId: 12,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 174, 177, 69, 70, 71, 72,
          73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94,
          95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
          111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Squash",
        nextQId: 12,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 78, 79, 80, 81, 82, 83, 69, 70, 71, 72,
          73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94,
          95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
          111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Cooked greens",
        nextQId: 12,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 84, 85, 86, 87, 176, 69, 70, 71, 72, 73,
          75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95,
          96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Mac and cheese is totally a vegetable",
        nextQId: 12,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 88, 89, 69, 70, 71, 72, 73, 75, 76, 77,
          154, 155, 156, 157, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98,
          99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161,
          162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 12,
    text: "How about a salad?",
    categoriesFiltered: ["salads"],
    options: [
      {
        text: "I need some kale",
        nextQId: 13,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 70, 61,
          73, 72, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102,
          104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113,
          114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127,
          166, 178,
        ],
      },
      {
        text: "Make sure it screams FALL!",
        nextQId: 13,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 71, 77,
          154, 155, 158, 159, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100,
          101, 102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163,
          164, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
          126, 127, 166, 178,
        ],
      },
      {
        text: "Make it crunchy and crisp",
        nextQId: 13,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 75, 76,
          156, 157, 69, 90, 91, 92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101,
          102, 104, 105, 106, 107, 108, 109, 110, 111, 112, 161, 162, 163, 164,
          113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
          127, 166, 178,
        ],
      },
      {
        text: "We're not here to eat salad",
        nextQId: 13,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 90, 91,
          92, 93, 160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106,
          107, 108, 109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 115, 116,
          117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 13,
    text: "Some people believe that cranberry sauce is Thanksgiving’s most essential condiment. How do you like yours?",
    categoriesFiltered: ["cranberry"],
    options: [
      {
        text: "Jiggly",
        nextQId: 14,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 94, 95, 96,
          97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Raw, relish-style",
        nextQId: 14,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 93, 94, 95, 96,
          97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110, 111,
          112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Cooked and jammy",
        nextQId: 14,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 91, 92, 160, 94,
          95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108, 109, 110,
          111, 112, 161, 162, 163, 164, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 14,
    text: "Which pie is your favorite?",
    categoriesFiltered: ["pie"],
    options: [
      {
        text: "Pumpkin",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 98, 164, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Apple",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 99, 100, 110, 162, 163, 113, 114, 115, 116, 117, 118, 119, 120,
          121, 122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Pecan",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 101, 102, 111, 161, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Sweet potato",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 97, 109, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Chocolate",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 105, 106, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122,
          123, 124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Banana cream or coconut cream",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 104, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123,
          124, 125, 126, 127, 166, 178,
        ],
      },
      {
        text: "Surprise me!",
        nextQId: 15,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 107, 108, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
          122, 123, 124, 125, 126, 127, 166, 178,
        ],
      },
    ],
  },
  {
    qId: 15,
    text: "Do you want to throw a wild card dessert in there?",
    categoriesFiltered: ["dessert"],
    options: [
      {
        text: "An elegant tart",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 113, 114, 124, 165, 178,
        ],
      },
      {
        text: "Something with cranberries!",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 115, 116, 119, 178,
        ],
      },
      {
        text: "Need a cake!",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 117, 118, 119, 126, 178,
        ],
      },
      {
        text: "Cheesecake, obviously",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 120, 125, 119, 127, 166, 178,
        ],
      },
      {
        text: "Cookies, please",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 121, 122, 123, 178,
        ],
      },
      {
        text: "None needed",
        nextQId: null,
        possibleResultsIds: [
          8, 9, 10, 11, 12, 13, 14, 15, 16, 170, 171, 172, 1, 2, 3, 4, 5, 6, 7,
          128, 129, 130, 131, 132, 133, 134, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144,
          145, 146, 147, 148, 149, 150, 151, 152, 153, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 173, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
          53, 54, 55, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 78, 79,
          80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 174, 175, 176, 177, 69, 70,
          71, 72, 73, 75, 76, 77, 154, 155, 156, 157, 158, 159, 90, 91, 92, 93,
          160, 94, 95, 96, 97, 98, 99, 100, 101, 102, 104, 105, 106, 107, 108,
          109, 110, 111, 112, 161, 162, 163, 164, 178,
        ],
      },
    ],
  },
]
